/**
 * Channel display labels — a shared, rendered data-model vocabulary used on both
 * web and mobile (e.g. `artifacts/mobile/constants/channels.ts`). Extend during
 * the channels slice to match the real channel set.
 */
export const channels = {
  music: "Music",
  ads: "Ads",
  announcements: "Announcements",
  video: "Video",
  screen: "Screen",
} as const;
